<template>
  <div class="home">
    <div class="home-page">
      <img src="@/assets/home/zylc-icon.png"
           class="icon zylc">
      <img src="@/assets/home/tips-icon.png"
           class="icon tips"
           @click="openTips">
      <!-- <img src="@/assets/home/listen-icon.png"
           class="icon listen-icon"> -->
      <img src="@/assets/home/home-title.png"
           class="home-title">
      <img src="@/assets/home/slide-tips.png"
           class="slide-tips">
      <div class="wish-box">
        <div class="wish-item"
             v-for="(item, index) in wishList"
             :key="index"
             @click="handleWish(item, index)">
          <img :src="item.img"
               class="item-img">
          <img src="@/assets/home/ischoose.png"
               class="ischoose"
               v-if="chooseList.includes(item.id)">
        </div>
      </div>
      <div class="select-box">
        <img src="@/assets/home/ischoose.png"
             class="select-icon">
        <p class="select-tips">已选{{chooseLen}}/6</p>
        <button class="select-btn"
                @click="makeWish"></button>
      </div>
    </div>

    <!-- 锦囊弹窗 -->
    <modal :show.sync="showTips">
      <div class="modal-tips">
        <div class="record"
             :class="tipSelect === 1 ? 'select' : 'noselect'"
             @click="isSelect(1)">中奖记录</div>
        <div class="rule"
             :class="tipSelect === 2 ? 'select' : 'noselect'"
             @click="isSelect(2)">活动规则</div>
        <div class="record-box"
             v-if="tipSelect === 1">
          <!-- 话费 -->
          <img src="@/assets/modal/coupon.png"
               class="coupon"
               v-if="prizeList && prizeList.type !== 3">
          <p class="coupon-text"
             v-if="prizeList && prizeList.type !== 3">联系电话：</p>
          <input class="coupon-input"
                 v-if="prizeList && prizeList.type !== 3"
                 maxlength="11"
                 v-model="prizeList.phone"
                 :disabled="isdisable">
          <p class="prize-name">{{prizeList.prize_name}}</p>
          <img src="@/assets/modal/icon.png"
               class="prize-icon"
               v-if="prizeList.type === 3">
        </div>
        <div class="rule-box"
             v-if="tipSelect === 2">
          <div class="rule-content"
               v-if="actInfo">
            <img src="@/assets/modal/up.png"
                 class="up">
            <img src="@/assets/modal/down.png"
                 class="down">
            <div class="rule-info"
                 v-html="actInfo.content"></div>
          </div>
        </div>
      </div>
    </modal>

    <div class="actend"
         v-if="actEnd">
      活动已下架
    </div>

    <loading></loading>
  </div>
</template>

<script>
import { Toast } from 'vant'
import Modal from '@/components/modal'
import list from './wish'
import '@/assets/text/text.css'
import _map from 'lodash.map'
import loading from '@/components/loading'
import Mia from '@inrice/mars-mia'
export default {
  components: { Modal, loading },
  data () {
    return {
      showTips: false,
      actEnd: false,
      wishList: [],
      chooseList: [],
      chooseLen: 0,
      tipSelect: 2,
      prizetype: 0,
      prizeName: '8.88元现金红包',
      actInfo: null,
      prizeList: [],
      isdisable: false,
      isclose: false,
      startTime: true,
      endTime: false
    }
  },
  async created () {
    console.log('version: 0.1.7')
    this.wishList = list.wishList
    this.$banShare()
    this.getAct()
    await this.getUser()
    await this.getPrize()
    // Mia.clickStat('home_view')
  },
  methods: {
    // 活动接口
    async getAct () {
      try {
        const { data } = await this.$fetch.get('/may-day-wish/act')
        console.log('act:', data)
        this.actInfo = data
        this.setWechatTitle(data.title)
        this.checkTime(data.start_time, data.end_time)
        return {}
      } catch (error) {
        console.log(error, 'dataerr')
        // console.log(error.status)
        if (error.status === 400) {
          // console.log(111)
          this.actEnd = true
        }
      }
    },
    // 用户接口
    async getUser () {
      const { data } = await this.$fetch.get('/may-day-wish/user')
      console.log('user:', data)
      this.useravatar = data.avatar
      return {}
    },
    // 奖品接口
    async getPrize () {
      const { data } = await this.$fetch.get('/may-day-wish/user-prize')
      console.log(data, 'prizelist')
      this.prizeList = data
      if (data.phone) {
        this.isdisable = true
      }
    },
    // 设置活动标题
    setWechatTitle (title) {
      document.title = title
      var iframe = document.createElement('iframe')
      iframe.style.visibility = 'hidden'
      iframe.setAttribute('src', 'https://www.baidu.com/img/baidu_jgylogo3.gif')
      var iframeCallback = function () {
        setTimeout(function () {
          iframe.removeEventListener('load', iframeCallback)
          document.body.removeChild(iframe)
        }, 0)
      }
      iframe.addEventListener('load', iframeCallback)
      document.body.appendChild(iframe)
    },
    // 判断时间
    checkTime (time1, time2) {
      const nowTime = (new Date()).valueOf()
      const new_time1 = time1.replace(/-/g, '/')
      const new_time2 = time2.replace(/-/g, '/')
      const startTime = new Date(new_time1).getTime()
      const endTime = new Date(new_time2).getTime()
      if (nowTime < startTime) {
        this.startTime = false
      } else if (nowTime > endTime) {
        this.endTime = true
      }
    },
    // 选择心愿
    handleWish (item, index) {
      if (!this.startTime) {
        Toast('活动未开始')
        return
      }
      if (this.endTime) {
        Toast('活动已结束')
        return
      }
      // if (!this.isclose) {
      //   this.$parent.$refs.music.toPlay()
      // }
      this.isclose = true
      if (this.chooseList.includes(item.id)) {
        for (let i = 0; i < this.chooseList.length; i++) {
          if (this.chooseList[i] === item.id) {
            this.chooseList.splice(i, 1)
          }
        }
        const arr2 = new Set(this.chooseList)
        this.chooseLen = [...arr2].length
        return
      }
      if (this.chooseLen === 6) {
        Toast('最多可选6个事件哟~')
        return
      }
      // console.log(item, index, 'item, index')
      this.chooseList.push(item.id)
      const arr1 = new Set(this.chooseList)
      this.chooseLen = [...arr1].length
      // console.log(this.chooseList, 'chooseList')
    },
    // 锦囊选择
    isSelect (num) {
      this.tipSelect = num
    },
    // 打开锦囊
    openTips () {
      this.showTips = true
    },
    // 许愿
    makeWish () {
      if (this.chooseLen < 6) {
        Toast('需选够6个事件哟~')
        return
      }
      this.chooseList.sort(this.func) // 排序
      // console.log(this.chooseList)
      // 转成对象数组
      const user_wish = _map(this.chooseList, n => {
        return {
          wish: n,
          isWish: true
        }
      })
      // console.log(user_wish, this.wishList, 'user_wish')
      // 两数组对比去重
      const DedArr = this.wishList.filter(item => !user_wish.some(ele => ele.wish === item.id))
      // console.log(DedArr, 'testarr')
      // 随机生成三个非选中
      const newList = DedArr
      const nolist = []
      for (let i = 0; i < 3; i++) {
        const _num = Math.floor(Math.random() * newList.length)
        const mm = newList[_num]
        newList.splice(_num, 1)
        nolist.push(mm)
      }
      // console.log(nolist, 'nolist')
      const unuser_wish = _map(nolist, n => {
        return {
          wish: n.id,
          isWish: false
        }
      })
      // console.log(unuser_wish, 'unuser_wish')
      // 合并两个数组
      // console.log(user_wish.concat(unuser_wish))
      // console.log(
      //   this.shuffle(
      //     user_wish.concat(unuser_wish)
      //   )
      //   ,
      //   '打乱'
      // )
      const sendList = this.shuffle(user_wish.concat(unuser_wish))
      this.toMakeWish(sendList)
    },
    async toMakeWish (wishArr) {
      try {
        const { data } = await this.$fetch.post('/may-day-wish/make-wish', {
          wish: wishArr
        })
        console.log(data, 'make wish')
        Mia.clickStat('home_sure')
        // this.$router.push('/poster')
        this.$router.push({
          path: '/poster',
          query: {
            wishId: data.id
          }
        })
      } catch (error) {
        console.log('make wish err', error)
        Toast(error.response.data.message)
      }
    },
    func (a, b) {
      return a - b
    },
    // 洗牌
    shuffle (arr) {
      const len = arr.length
      for (let i = 0; i < len - 1; i++) {
        const index = parseInt(Math.random() * (len - i))
        const temp = arr[index]
        arr[index] = arr[len - i - 1]
        arr[len - i - 1] = temp
      }
      return arr
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  position: absolute;
  z-index: 2;
}
.home {
  width: 100%;
  min-height: 1700px;
  height: 100vh;
  background-color: #cbc2ae;
}
.home-page {
  position: relative;
  background: url(~@/assets/home/home-bg.png) no-repeat;
  background-size: 100%;
  width: 750px;
  min-height: 1700px;
  padding-top: 132px;
  .zylc {
    width: 212px;
    height: 52px;
    top: 40px;
    left: 48px;
  }
  .tips {
    width: 57px;
    height: 57px;
    top: 55px;
    left: 550px;
  }
  .listen-icon {
    width: 63px;
    height: 60px;
    top: 59px;
    left: 656px;
  }
  .home-title {
    width: 653px;
    height: 380px;
    display: block;
    margin: 0 auto;
  }
  .slide-tips {
    position: absolute;
    top: 510px;
    left: 709px;
    width: 31px;
    height: 248px;
  }
  .wish-box {
    width: 652px;
    height: 1188px;
    background-color: #ffffff;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    overflow: auto;
    padding-bottom: 180px;
    .wish-item {
      width: 177px;
      height: 256px;
      margin-bottom: 25px;
      position: relative;
      .ischoose {
        position: absolute;
        width: 42px;
        height: 38px;
        right: 3px;
        bottom: 17px;
      }
    }
  }
  .select-box {
    position: fixed;
    bottom: 0;
    width: 750px;
    height: 154px;
    background: #fffbfc;
    box-shadow: 0px 2px 5px 0px rgba(7, 0, 2, 0.3);
    border-radius: 20px 20px 0px 0px;
    .select-icon {
      width: 42px;
      height: 38px;
      position: absolute;
      top: 58px;
      left: 50px;
    }
    .select-tips {
      width: auto;
      font-size: 34px;
      font-family: HappyZcool-2016;
      font-weight: 400;
      color: #000000;
      position: absolute;
      top: 60px;
      left: 115px;
    }
    .select-btn {
      width: 189px;
      height: 85px;
      position: absolute;
      top: 39px;
      left: 527px;
      background: url(~@/assets/home/sure-btn.png) no-repeat;
      background-size: 100%;
      border: none;
    }
  }
}
.modal-tips {
  width: 672px;
  height: 454px;
  margin-bottom: 40px;
  position: relative;
  font-family: HappyZcool-2016;
  padding-top: 37px;
  .record {
    width: 237px;
    height: 77px;
    position: absolute;
    top: 0;
    left: 74px;
    background: url(~@/assets/modal/record-noselect.png) no-repeat;
    background-size: 100%;
    &.select {
      background: url(~@/assets/modal/record-select.png) no-repeat;
      background-size: 100%;
    }
  }
  .rule {
    width: 240px;
    height: 84px;
    position: absolute;
    top: 0;
    left: 345px;
    background: url(~@/assets/modal/rule-noselect.png) no-repeat;
    background-size: 100%;
    &.select {
      background: url(~@/assets/modal/rule-select.png) no-repeat;
      background-size: 100%;
    }
  }
  .record,
  .rule {
    padding-top: 18px;
    font-size: 35px;
    font-weight: 400;
    color: #3b3125;
    text-align: center;
    z-index: 2;
  }
  .rule-box,
  .record-box {
    width: 672px;
    height: 441px;
    background: url(~@/assets/modal/modal-bg.png) no-repeat;
    background-size: 100%;
    position: relative;
    .coupon {
      position: absolute;
      width: 351px;
      height: 105px;
      top: 45px;
      left: 146px;
    }
    .coupon-text {
      width: auto;
      font-size: 22px;
      font-weight: 400;
      color: #3b3125;
      position: absolute;
      top: 295px;
      left: 77px;
    }
    .coupon-input {
      width: 307px;
      height: 70px;
      background: url(~@/assets/modal/input.png) no-repeat;
      background-size: 100%;
      position: absolute;
      top: 280px;
      left: 189px;
      font-size: 22px;
      font-weight: 400;
      color: #3b3125;
      line-height: 67px;
      text-align: center;
    }
    .change,
    .submit {
      width: 224px;
      height: 76px;
      position: absolute;
      top: 288px;
      left: 214px;
    }
    .submit {
      background: url(~@/assets/modal/submit.png) no-repeat;
      background-size: 100%;
    }
    .change {
      background: url(~@/assets/modal/change.png) no-repeat;
      background-size: 100%;
    }
    .prize-name {
      width: 100%;
      font-size: 52px;
      font-weight: 400;
      color: #3b3125;
      text-align: center;
      padding-top: 195px;
    }
    .prize-icon {
      width: 224px;
      height: 76px;
      position: absolute;
      top: 304px;
      left: 417px;
    }
  }
  .rule-box {
    padding-top: 109px;
    .rule-content {
      width: 584px;
      height: 261px;
      background: url(~@/assets/modal/rule-bg.png) no-repeat;
      background-size: 100%;
      margin: 0 auto;
      position: relative;
      padding-top: 58px;
      .up,
      .down {
        width: 19px;
        height: 18px;
        position: absolute;
        left: 539px;
        top: 51px;
      }
      .down {
        top: 192px;
      }
      .rule-info {
        width: 497px;
        height: 160px;
        margin: 0 auto;
        overflow: auto;
        font-weight: 400;
        color: #3b3125;
        font-size: 22px;
      }
    }
  }
}
.actend {
  width: 750px;
  height: 100vh;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  font-size: 48px;
  text-align: center;
  padding-top: 400px;
}
</style>